module.exports = __webpack_public_path__ + "img/telehealth.fb4478bc.png";